import { type SerializedNodeDto } from '@builder4/shared/dto/craft';

export abstract class MigratableJson {
  abstract version?: number;
  abstract getAllNodes(): Array<{ id: string; node: SerializedNodeDto }>;
}
